import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        department: '='
    },
    template: `
        <h1>{{ 'user.Add department' | translate }}</h1>
        <user-group-form-department form="vm.form" department="vm.department"/>
`
})
export default class {
    constructor (FormFactory) {
        this.form = FormFactory.create(this.department, model => model.$save());
    }
}




// WEBPACK FOOTER //
// ./src/app/components/user/group/add/department/index.js